// src/three/loop/createLoop.js
export function createLoop({
  renderer,
  scene,
  camera,
  controls,
  meshRef,
  isRotateAniRef,
}) {
  let req = 0;
  let last = 0;

  function frame(time) {
    req = requestAnimationFrame(frame);
    const dt = last ? (time - last) / 1000 : 0; // s
    last = time;

    const m = meshRef.current;
    if (m && isRotateAniRef.current) {
      m.rotation.y += 0.5 * dt; // 초당 0.5rad
    }

    controls.update();
    renderer.render(scene, camera);
  }

  return {
    start() {
      req = requestAnimationFrame(frame);
    },
    stop() {
      if (req) cancelAnimationFrame(req);
    },
  };
}
